import { Fragment } from 'react';
import Modal from './Modal';
import CyoSelector from './CyoSelector';
import styles from './CyoModal.module.css';

const CyoModalWrapper = ({ closeModal }) => {
  return (
    <Fragment>
      <div className="hr-title-sectra-lg hr-mb-8 hr-align-center">
        Want to swap your
        <br className={styles['hr-mobile']} /> free gift for life?{' '}
      </div>
      <div className="hr-paragraph hr-mb-24 hr-align-center">
        Select any of these items. We’ll update all future deliveries with your
        new pick.{' '}
      </div>
      <CyoSelector
        onButtonClick={closeModal}
        location={'modal'}
        smallImages={true}
      />
      <span className="close" onClick={closeModal}></span>
    </Fragment>
  );
};

const CyoModal = ({ visible, onClose }) => {
  return (
    <div className="cyo-modal">
      <Modal visible={visible} onClose={onClose}>
        <CyoModalWrapper />
      </Modal>
    </div>
  );
};

export default CyoModal;
